import axios from "../Axios";

export default {

  async login(user) {
    try {
      var response = await axios.post(`/admin/login`, {
        email: user.email,
        password: user.password,
      });
      
      // Handle different response structures
      let userData = null;
      
      if (response.data) {
        // Check if data is nested (response.data.data)
        if (response.data.data) {
          const data = response.data.data;
          
          // If user object is nested inside data (e.g., {user: {...}, token: '...'})
          if (data.user && data.token) {
            // Flatten the structure: merge user properties with token at top level
            userData = {
              ...data.user,
              token: data.token
            };
          } else {
            // Otherwise, use data directly
            userData = data;
          }
        } 
        // Check if data is directly in response.data
        else if (response.data.token || response.data.type) {
          userData = response.data;
        }
      }
      
      // Log the response for debugging
      console.log('Login response:', response.data);
      console.log('Extracted userData:', userData);
      
      if (userData && userData.token) {
        localStorage.setItem("user_free", JSON.stringify(userData));
        return userData;
      } else {
        console.error('Login failed: No user data or token in response');
        throw new Error('Invalid response structure from login endpoint');
      }
    } catch (error) {
      console.error('Login error:', error);
      // Re-throw to let the caller handle it
      throw error;
    }
  },

  // async logout() {
  //   await axios.post(`/auth/logout`, {}, { headers: authHeader() })
  //   localStorage.removeItem('user_free');
  // },
  async logout() {
    const stored = localStorage.getItem('user_free');
    const token = stored ? JSON.parse(stored).token : null;

    if (token) {
      try {
        await axios.post(`/auth/logout`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          }
        });
      } catch (error) {
        if (error.response?.status === 401) {
          console.log("⚠️ Token expired, clearing localStorage");
        } else {
          throw error;
        }
      }
    }

    localStorage.removeItem('user_free');
    localStorage.removeItem('user_data');
  },
}
